import formatPercent from "../../hooks/formatPercent";
import { useState, useEffect, useMemo } from "react";
import BreadcrumbPurchase from "./purchaseComponents/BreadcrumbPurchase";
import PurchaseHeader from "./purchaseComponents/PurchaseHeader";
import { useNavigate } from "react-router-dom";
import { Checkbox, CircularProgress, FormControlLabel } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  checkallCartProduct,
  getCartDetails,
} from "../../../services/purchaseApi";
import { FaMinus, FaPlus, FaRegTrashAlt } from "react-icons/fa";
import RemoveProductCartPopup from "./purchaseComponents/RemoveProductCartPopup";
import EmptyList from "../../ui/EmptyList";
import LoadingBackdrop from "../../common/particles.jsx/LoadingBackdrop";
import { useUpdateCartPbf } from "../../hooks/purchaseHook/updateCartPbf";
import { useAddToCartPbf } from "../../hooks/purchaseHook/addToCartPbf";
import { UseCartQueryPbf } from "../../hooks/purchaseHook/useCartQueryPbf";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";
import PbfRefusalDialog from "./purchaseComponents/PbfRefusalDialog";
import NearExpiryConfirmPopup from "./purchaseComponents/NearExpiryConfirmPopup";
import {
  BLOCKED_ITEM_LINE,
  hasBlockedCheckedItem,
  isPbfRefusal,
  nearExpiryLabel,
  quotaCapHint,
  quotaCartLabel,
  stepperMax,
} from "./purchaseComponents/pbfInventoryText";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const PurchaseCart = () => {
  const navigate = useNavigate();

  const [selectCartArr, setSelectCartArr] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteProduct, setDeleteProduct] = useState(null);
  const [qtyOrderArr, setQtyOrderArr] = useState([]);
  const [isSingularRemove, setIsSingularRemove] = useState(false);
  const [refusal, setRefusal] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [nearExpiryItems, setNearExpiryItems] = useState(null);

  const addToCart = useAddToCartPbf();
  const updateCart = useUpdateCartPbf();
  const {
    data: dataCart,
    isFetching: isFetchingCart,
    refetch: refetchCart,
  } = UseCartQueryPbf();

  const resetCart = () => {
    const tempCheckArr = [];
    const tempQtyArr = [];

    dataCart.items.map((product) => {
      if (product.is_checked) tempCheckArr.push(product);
      tempQtyArr.push({
        pbf_product_uuid: product.pbf_product_uuid,
        qty: product.qty,
      });
    });

    setSelectCartArr(tempCheckArr);
    setQtyOrderArr(tempQtyArr);
  };

  const handleAddToCart = (product, newQty, newCheck) => {
    if (newQty === 0) {
      setDeleteProduct(product);
      setOpenDelete(true);
      return;
    }

    var body = {
      product_uuid: product.pbf_product_uuid,
      qty: newQty,
      is_checked: newCheck,
    };

    updateCart.mutate(body, {
      onError: (err) => {
        if (isPbfRefusal(err)) setRefusal(err);
        else
          setErrorMessage(
            err?.message?.id ?? err?.message ?? "Gagal memperbarui keranjang",
          );
      },
    });
  };

  const handleBuy = () => {
    const items = dataCart.items.filter(
      (item) => item.is_checked && item.near_expiry,
    );
    if (items.length > 0) setNearExpiryItems(items);
    else navigate(`/purchase-pbf/checkout`);
  };

  const hasBlockedItem = hasBlockedCheckedItem(dataCart?.items);

  const handleSelectPbf = (pbf) => {
    const isPbfSelected = pbf.every((item) => selectCartArr.includes(item));

    var tempArr = [...selectCartArr];
    pbf.map((product) => {
      var index = selectCartArr.findIndex(
        (item) => item.product_id === product.product_id,
      );
      if (!isPbfSelected && index < 0) tempArr = [...tempArr, product];
      if (isPbfSelected)
        tempArr = tempArr.filter(
          (item) => item.product_id !== product.product_id,
        );
    });

    // difference between both array
    const diff1 = tempArr.filter((item) => !selectCartArr.includes(item));
    const diff2 = selectCartArr.filter((item) => !tempArr.includes(item));
    const totalDiff = [...diff1, ...diff2];

    totalDiff.forEach((product) => {
      setTimeout(() => {
        handleAddToCart(product, product.qty, !isPbfSelected);
      }, 300);
    });
  };

  const getTotalPrice = () => {
    // return selectCartArr.reduce(
    //   (acc, num) =>
    //     acc +
    //     // (num.price_discount > 0 ? num.price_discount : num.price) *
    //     (num.discount &&
    //     Array.isArray(num.discount) &&
    //     num.discount[0]?.value > 0
    //       ? num.price * ((100 - getDiscount(num)) / 100)
    //       : num.price) *
    //       num.qty,
    //   0,
    // );

    return dataCart?.summary.grand_total_estimate;
  };

  const getDiscount = (product) => {
    return product.discount?.percent;
  };

  const getBonus = (product) => {
    return product.bonus_info?.findLast(
      (disc) =>
        qtyOrderArr.find(
          (item) => item.pbf_product_uuid === product.pbf_product_uuid,
        )?.qty >= disc.min_qty,
    );
  };

  const { mutate: mutateCheckAllCart, isLoading: isLoadingCheckAllCart } =
    useMutation({
      mutationFn: checkallCartProduct,
      onSuccess: () => refetchCart(),
    });

  const cartByPbf = useMemo(() => {
    if (!dataCart || (dataCart && !dataCart.items)) return null;
    // else return Object.groupBy(dataCart.items, ({ pbf }) => pbf);
    else {
      resetCart();
      return dataCart.items;
    }
  }, [dataCart]);

  useEffect(() => {
    refetchCart();
  }, []);

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <LoadingBackdrop
        isLoading={
          isFetchingCart || updateCart.isLoading || isLoadingCheckAllCart
        }
      />
      <PurchaseHeader />

      <div className="mt-[70px]">
        <div className="px-3 pt-2 mb-4">
          <BreadcrumbPurchase />
        </div>
        <div className="px-3 mb-4">
          <p className="text-[24px] font-semibold">Keranjang Belanja</p>
        </div>
        {dataCart && dataCart.items && cartByPbf.length > 0 ? (
          <div className="px-3 mb-4 flex flex-col-reverse lg:flex-row gap-4">
            <div className="w-full bg-white rounded-lg p-4 h-fit">
              <div className="flex justify-between items-center">
                <FormControlLabel
                  control={<Checkbox disabled={updateCart.isLoading} />}
                  label="Pilih Semua"
                  checked={
                    cartByPbf.length === 0
                      ? false
                      : cartByPbf.length === selectCartArr.length
                  }
                  onChange={(_, checked) => mutateCheckAllCart(checked)}
                  disabled={cartByPbf.length === 0}
                />
                {selectCartArr.length > 0 ? (
                  <p
                    className="font-semibold cursor-pointer hover:text-gray-300"
                    onClick={() => {
                      setDeleteProduct(null);
                      setOpenDelete(true);
                    }}
                  >
                    Hapus
                  </p>
                ) : null}
              </div>
              <hr className="my-2" />
              <div className="">
                {dataCart && dataCart.items && cartByPbf ? (
                  cartByPbf.map((product, i) => {
                    const maxQty = stepperMax(
                      product.stock_available,
                      product.quota,
                    );
                    return (
                      <div>
                        <div>
                          {/* <FormControlLabel
                            control={
                              <Checkbox disabled={updateCart.isLoading} />
                            }
                            label={value[0]?.pbf}
                            sx={{ marginTop: index === 0 ? 0 : 2 }}
                            checked={value.every((item) =>
                              selectCartArr.includes(item),
                            )}
                            onChange={(_, checked) =>
                              cartByPbf.length === 1
                                ? mutateCheckAllCart(checked)
                                : handleSelectPbf(value)
                            }
                          /> */}
                          {/* {value.map((product, i) => { */}
                          {/* return ( */}
                          <div>
                            <div
                              className={`md:flex gap-4 items-center justify-between ${
                                i === 0 ? "" : "mt-4"
                              }`}
                            >
                              <div className="flex items-center gap-4">
                                <Checkbox
                                  disabled={updateCart.isLoading}
                                  checked={product.is_checked}
                                  onChange={(_, checked) => {
                                    handleAddToCart(
                                      product,
                                      product.qty,
                                      checked,
                                    );
                                  }}
                                />
                                <div className="w-full">
                                  <div className="flex items-center gap-4">
                                    <img
                                      src={product.image}
                                      className="w-[70px] h-[70px] md:w-[100px] md:h-[100px] object-contain rounded-md border-2"
                                    />
                                    <div>
                                      <p
                                        className={`py-1 px-3 mb-2 rounded-full w-fit truncate
                                  ${
                                    product.label === "Alat Kesehatan"
                                      ? "bg-[#F9EBFE] text-[#AA31F6]"
                                      : product.label ===
                                          "Obat Obat Tertentu (OOT)"
                                        ? "bg-[#FFE7E7] text-[#C62828]"
                                        : product.label === "Obat Prekursor"
                                          ? "bg-[#FFE4E4] text-[#FF0000]"
                                          : product.label ===
                                              "Obat Psikotropika"
                                            ? "bg-[#FEEBF7] text-[#F6317D]"
                                            : "bg-[#EBF5FE] text-[#3194F6]"
                                  }`}
                                      >
                                        {product.label}
                                      </p>
                                      <p className="text-[16px] font-semibold">
                                        {product.name}
                                      </p>
                                      <div className="w-full hidden md:flex gap-2 items-center">
                                        {product.discount &&
                                        product.discount?.percent > 0 ? (
                                          <p>
                                            <s>{toIDR(product.unit_price)}</s>
                                          </p>
                                        ) : null}
                                        {product.discount &&
                                        product.discount?.percent > 0 ? (
                                          <p className="bg-red-100 text-red-500 p-1 rounded-lg">
                                            {formatPercent(getDiscount(product))}
                                          </p>
                                        ) : null}
                                        <p>
                                          {toIDR(
                                            product.discount &&
                                              product.discount?.percent > 0
                                              ? // ? product.price_discount
                                                product.unit_price *
                                                  ((100 -
                                                    getDiscount(product)) /
                                                    100)
                                              : product.unit_price,
                                          )}{" "}
                                          x {product.qty}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="block md:hidden my-4 flex justify-between items-end w-full">
                                    <div>
                                      <div className="flex gap-2 items-center">
                                        {product.discount &&
                                        product.discount?.percent > 0 ? (
                                          <p>
                                            <s>{toIDR(product.unit_price)}</s>
                                          </p>
                                        ) : null}
                                        {product.discount &&
                                        product.discount?.percent > 0 ? (
                                          <p className="bg-red-100 text-red-500 p-1 rounded-lg">
                                            {formatPercent(getDiscount(product))}
                                          </p>
                                        ) : null}
                                      </div>
                                      <p className="font-semibold">
                                        {toIDR(
                                          product.discount &&
                                            product.discount?.percent > 0
                                            ? product.unit_price *
                                                ((100 - getDiscount(product)) /
                                                  100)
                                            : product.unit_price,
                                        )}{" "}
                                        x {product.qty}
                                      </p>
                                    </div>
                                    <div className="text-right font-semibold">
                                      {toIDR(product.total_price)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <p className="hidden md:block mb-2 text-right">
                                  {toIDR(product.total_price)}
                                </p>
                                <div className="flex gap-4 items-center justify-end">
                                  <button
                                    type="button"
                                    className="text-red-500 text-[20px] cursor-pointer hover:text-gray-300 disabled:text-gray-300"
                                    disabled={updateCart.isLoading}
                                    onClick={() => {
                                      setDeleteProduct(product);
                                      setOpenDelete(true);
                                    }}
                                  >
                                    <FaRegTrashAlt />
                                  </button>
                                  <div className="flex items-center gap-2 w-full rounded-md border-2 p-2 bg-white w-fit">
                                    <button
                                      type="button"
                                      disabled={updateCart.isLoading}
                                      className={`text-[16px] hover:text-gray-300 text-gray-500 disabled:text-gray-300`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleAddToCart(
                                          product,
                                          product.qty - 1,
                                          product.is_checked,
                                        );
                                      }}
                                    >
                                      <FaMinus />
                                    </button>
                                    <input
                                      className="w-[80px] text-center focus:outline-none"
                                      type="text"
                                      disabled={
                                        updateCart.isLoading ||
                                        (product.stock_available
                                          ? product.stock_available === 0
                                          : product.qty === 0)
                                      }
                                      value={
                                        qtyOrderArr.find(
                                          (item) =>
                                            item.pbf_product_uuid ===
                                            product.pbf_product_uuid,
                                        )?.qty
                                      }
                                      onChange={(e) => {
                                        if (!isNaN(Number(e.target.value))) {
                                          const index = qtyOrderArr.findIndex(
                                            (item) =>
                                              item.product_id ===
                                              product.product_id,
                                          );
                                          setQtyOrderArr([
                                            ...qtyOrderArr.slice(0, index),
                                            {
                                              pbf_product_uuid:
                                                product.pbf_product_uuid,
                                              qty: Math.min(
                                                Number(e.target.value),
                                                maxQty,
                                              ),
                                            },
                                            ...qtyOrderArr.slice(index + 1),
                                          ]);
                                          setTimeout(() => {
                                            handleAddToCart(
                                              product,
                                              Math.min(
                                                Number(e.target.value),
                                                maxQty,
                                              ),
                                              product.is_checked,
                                            );
                                          }, 1500);
                                        }
                                      }}
                                    />
                                    <button
                                      type="button"
                                      className={`text-[16px] hover:text-gray-300 text-gray-500 disabled:text-gray-300`}
                                      disabled={
                                        updateCart.isLoading ||
                                        product.qty + 1 > maxQty ||
                                        maxQty === 0
                                      }
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleAddToCart(
                                          product,
                                          product.qty + 1,
                                          product.is_checked,
                                        );
                                      }}
                                    >
                                      <FaPlus />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="pl-[42px] mt-1">
                              {product.warnings?.map((warning) => (
                                <p key={warning} className="text-red-500">
                                  {warning}
                                </p>
                              ))}
                              {product.quota ? (
                                <p className="text-gray-500">
                                  {quotaCartLabel(product.quota)}
                                </p>
                              ) : null}
                              {product.quota &&
                              product.quota.remaining > 0 &&
                              product.qty === maxQty &&
                              maxQty === product.quota.remaining ? (
                                <p className="text-gray-500">
                                  {quotaCapHint(product.quota)}
                                </p>
                              ) : null}
                              {product.near_expiry ? (
                                <p className="text-[#F5A623]">
                                  {nearExpiryLabel(
                                    product.near_expiry,
                                    product.qty,
                                    product.uom,
                                  )}
                                </p>
                              ) : null}
                            </div>

                            {getBonus(product) ? (
                              <div className="my-4 pl-20 md:pl-28 flex w-full gap-4 items-center overflow-hidden truncate">
                                <img
                                  src={getBonus(product).image}
                                  className="w-[60px] h-[60px] md:w-[70px] md:h-[70px] object-contain rounded-md border-2"
                                />
                                <div className="w-full">
                                  <p className="w-full truncate overflow-hidden">
                                    <span className="font-bold">Gratis</span>{" "}
                                    {getBonus(product).name}
                                  </p>
                                  <p>{getBonus(product).qty_bonus}</p>
                                </div>
                              </div>
                            ) : null}
                          </div>
                          {/* ); */}
                          {/* })} */}
                        </div>
                      </div>
                    );
                  })
                ) : isFetchingCart ? (
                  <CircularProgress size={20} />
                ) : null}
              </div>
            </div>
            <div className="w-full lg:basis-1/2">
              <div className="bg-white rounded-lg p-4 h-fit mb-4">
                <p className="text-[20px] mb-4 font-bold">Detail Pesanan</p>
                <div className="flex items-center justify-between mb-2">
                  <p>Total Harga ({selectCartArr.length} produk)</p>
                  <p>{toIDR(dataCart.summary.subtotal)}</p>
                </div>
                <div className="flex items-center justify-between mb-2">
                  <p>Pajak</p>
                  <p>{toIDR(dataCart.summary.ppn_amount)}</p>
                </div>
                <div className="flex items-center justify-between mb-2">
                  <p>Biaya Admin</p>
                  <p>{toIDR(0)}</p>
                </div>
                <hr className="mb-2" />
                <div className="flex items-center justify-between mb-2">
                  <p className="text-[16px] font-bold">Total</p>
                  <p className="text-[20px] font-semibold text-red-500">
                    {toIDR(dataCart.summary.grand_total_estimate)}
                  </p>
                </div>
              </div>
              <p className="text-red-500 mb-4">
                {dataCart?.summary?.subtotal < 250000
                  ? "Minimal belanja Rp250.000 untuk dapat melanjutkan pembelian"
                  : ""}
              </p>
              {hasBlockedItem ? (
                <p className="text-red-500 mb-4">{BLOCKED_ITEM_LINE}</p>
              ) : null}
              <div className="flex lg:block items-center gap-4">
                <button
                  type="button"
                  disabled={
                    selectCartArr.length === 0 ||
                    dataCart?.summary?.subtotal < 250000 ||
                    hasBlockedItem
                  }
                  className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-full p-2.5 text-[14px] disabled:bg-gray-300 lg:mb-2"
                  onClick={handleBuy}
                >
                  Beli
                </button>
                <button
                  type="button"
                  className="flex items-center justify-center text-[#6F955B] border-2 border-[#6F955B] bg-[#F1FAF0] hover:bg-gray-300 rounded-md w-full p-2.5 text-[14px] disabled:bg-gray-300"
                  onClick={() => navigate(`/purchase-pbf`)}
                >
                  <p className="inline-block">
                    Tambah Produk{" "}
                    <span className="hidden sm:inline-block">{" Lainnya"}</span>
                  </p>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full">
            <EmptyList
              message={
                <div className="text-center">
                  <p className="text-xl align-center mt-8 mb-1">
                    Keranjang Masih Kosong
                  </p>
                  <p className="text-[12px] mb-3">
                    Ayo mulai cari barang yang kamu butuhkan
                  </p>
                  <button
                    type="button"
                    className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-full p-2 text-[14px]"
                    onClick={() => navigate(`/purchase-pbf`)}
                  >
                    Mulai Belanja
                  </button>
                </div>
              }
            />
          </div>
        )}
      </div>

      <RemoveProductCartPopup
        open={openDelete}
        setOpen={setOpenDelete}
        productArr={deleteProduct ? [deleteProduct] : selectCartArr}
        closeFunc={() => {
          setDeleteProduct(null);
          resetCart();
        }}
        successCloseFunc={() => {
          setSelectCartArr([]);
          setDeleteProduct(null);
          refetchCart();
        }}
        isAll={
          cartByPbf && !deleteProduct
            ? cartByPbf.length === selectCartArr.length
            : false
        }
      />
      <PbfRefusalDialog
        error={refusal}
        title="Tidak dapat ditambahkan"
        onClose={() => setRefusal(null)}
      />
      <NearExpiryConfirmPopup
        items={nearExpiryItems}
        onCancel={() => setNearExpiryItems(null)}
        onConfirm={() => navigate(`/purchase-pbf/checkout`)}
      />
      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};

export default PurchaseCart;
